import type { ImpactStats } from '../types';

export type CitationsCellMetric = 'citations' | 'mentions';

export interface CitationsCell {
  metric: CitationsCellMetric;
  label: 'Citations' | 'Mentions';
  count: number | null;
  trendPct: number | null;
}

export function citationsCell(
  impactStats: ImpactStats | null | undefined,
): CitationsCell {
  const citations = impactStats?.citations ?? null;

  if (citations === 0) {
    return {
      metric: 'mentions',
      label: 'Mentions',
      count: impactStats?.mentions ?? 0,
      trendPct: impactStats?.mentionsTrendPct ?? null,
    };
  }

  return {
    metric: 'citations',
    label: 'Citations',
    count: citations,
    trendPct: impactStats?.citationsTrendPct ?? null,
  };
}
